import { Box, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

type RequiredOneInSpecifiedKeys<T, Keys extends keyof T> = Keys extends keyof T
  ? PartialRequire<T, Keys>
  : never;
type PartialRequire<O, Keys extends keyof O> = {
  [K in Keys]-?: O[K];
} & O;

type Props = RequiredOneInSpecifiedKeys<
  {
    title?: string;
    children: ReactNode;
    titleComponent?: ReactNode;
    sx?: SxProps;
  },
  "title" | "titleComponent"
>;

/**
 * SurroundLine
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function SurroundLine({ title, children, titleComponent, sx }: Props) {
  return (
    <Box
      mt={1}
      mb={1}
      pt={0.5}
      border="dashed 2px"
      borderRadius={2}
      borderColor="secondary.main"
      position="relative"
      sx={sx}
    >
      {titleComponent ?? (
        <Box position="absolute" top={-10} left={8} px={1} sx={{ backgroundColor: "white" }}>
          <Typography fontSize={14} color="secondary.main">
            {title}
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}
